/**
 * What a note save / delete must refresh besides the notes list (which
 * `useSaveNote` / `useDeleteNote` already invalidate): the family cards of the
 * job carry `card.notes`, so only those keys — never the whole job cache
 * (every timeline / actions / graph query would refetch for one note).
 */
import type { QueryClient } from "@tanstack/react-query";
import { qk } from "@/api/keys";

/** One family card (`qk.family`), when the family is known. */
export function invalidateFamilyCard(qc: QueryClient, chain: string, token: string, family: string): void {
  void qc.invalidateQueries({ queryKey: qk.family(chain, token, family.toLowerCase()), exact: true });
}

/**
 * Every family card of a job (keys `["job", jobId, "family", <addr>]` and
 * nothing deeper) — for the composer, which only knows the note's job id.
 */
export function invalidateFamilyCards(qc: QueryClient, jobId: string): void {
  void qc.invalidateQueries({
    predicate: (q) => {
      const k = q.queryKey;
      return k.length === 4 && k[0] === "job" && k[1] === jobId && k[2] === "family";
    },
  });
}
